webpackJsonp([4],{

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(43)(
  /* script */
  __webpack_require__(291),
  /* template */
  __webpack_require__(314),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(304);

/***/ }),

/***/ 297:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(273)();
// imports


// module
exports.push([module.i, ".not-found{position:fixed;width:100%;height:100%;background:#353535;text-align:center}.not-found .not-found-wrap{display:inline-block;margin:5% 0}.not-found .not-found-wrap h1{font-size:11em;color:#fff}.not-found .not-found-wrap p{color:#fff;margin-bottom:50px}.not-found .not-found-wrap p.joke{margin-top:30px}.not-found .not-found-wrap p.joke a{display:inline-block;color:#1a1a1a;width:98%;height:100px;border-radius:50px;background:#fff;line-height:100px;font-size:30px;font-weight:100}", "", {"version":3,"sources":["D:/project/lipan82-atlanta.jizhuoyangqing.com/src/static/style/common/D:\\project\\lipan82-atlanta.jizhuoyangqing.com/src\\static\\style\\common\\notfound.scss"],"names":[],"mappings":"AAAA,WACI,eAAe,AACf,WAAW,AACX,YAAY,AACZ,mBAAmB,AACnB,iBAAkB,CA2BrB,AAhCD,2BAOQ,qBAAqB,AACrB,WAAY,CAuBf,AA/BL,8BAUY,eAAe,AACf,UAAW,CACd,AAZT,6BAcY,WAAW,AACX,kBAAmB,CACtB,AAhBT,kCAkBY,eAAe,CAYlB,AA9BT,oCAoBgB,qBAAqB,AACrB,cAAa,AACb,UAAS,AACT,aAAa,AACb,mBAAkB,AAClB,gBAAiB,AACjB,kBAAkB,AAClB,eAAc,AACd,eAAgB,CACnB","file":"notfound.scss","sourcesContent":[".not-found {\r\n    position: fixed;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: #353535;\r\n    text-align: center;\r\n    .not-found-wrap {\r\n        display: inline-block;\r\n        margin: 5% 0;\r\n        h1 {\r\n            font-size: 11em;\r\n            color: #fff;\r\n        }\r\n        p {\r\n            color: #fff;\r\n            margin-bottom: 50px;\r\n        }\r\n        p.joke {\r\n            margin-top:30px;\r\n            a{\r\n                display: inline-block;\r\n                color:#1A1A1A;\r\n                width:98%;\r\n                height: 100px;\r\n                border-radius:50px;\r\n                background: white;\r\n                line-height: 100px;\r\n                font-size:30px;\r\n                font-weight: 100;\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(297);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(274)("976e5f0e", content, true);

/***/ }),

/***/ 314:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "not-found"
  }, [_c('div', {
    staticClass: "not-found-wrap"
  }, [_c('h1', [_vm._v("404")]), _vm._v(" "), _c('p', [_vm._v("抱歉！页面没找到……点击按钮返回首页或幽默笑话")]), _vm._v(" "), _c('p', {
    staticClass: "joke"
  }, [_c('router-link', {
    attrs: {
      "to": "./"
    }
  }, [_vm._v("返回首页")])], 1), _vm._v(" "), _c('p', {
    staticClass: "joke"
  }, [_c('router-link', {
    attrs: {
      "to": "./joke/list"
    }
  }, [_vm._v("幽默笑话")])], 1)])])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/4.fa21a6aba201fa860bf2.js